import { Dashboard as DashboardContainer } from "containers/Dashboard/Dashboard";
import { withUser } from "lib/hoc/withUser";
import { Platform } from "react-native";

export const Dashboard = withUser(DashboardContainer, Platform.OS === "web");
